(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Bundle', Bundle);

    Bundle.$inject = ['$resource'];

    function Bundle ($resource) {
        var resourceUrl =  'api/bundles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
